module.exports = __webpack_public_path__ + "img/3.1d63851a.png";